import { createTheme } from "@mui/material/styles";

import colors from "./colors";

const theme = createTheme({
    palette: {
        primary: {
            light: colors.skyHover,
            main: colors.sky,
            dark: colors.skySelected,
        },
        secondary: {
            light: colors.nightHover,
            main: colors.night,
            dark: colors.nightSelected,
        },
    },
    typography: {
        fontFamily: ["Roboto", '"Helvetica Neue"', "Arial", "sans-serif"].join(
            ",",
        ),
        fontWeight: 400,
    },
    components: {
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true, // No more ripple effect
            },
        },
        MuiTextField: {
            defaultProps: {
                variant: "standard", // Restore underline-style inputs from v4
            },
        },
        MuiSelect: {
            defaultProps: {
                variant: "standard", // Restore underline-style selects from v4
            },
        },
        MuiFormControl: {
            defaultProps: {
                variant: "standard", // Restore underline-style form controls from v4
            },
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    fontSize: "14px",
                },
                asterisk: {
                    color: colors.cautionRed,
                    "&.Mui-error": {
                        color: colors.cautionRed,
                    },
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: "none",
                },
            },
        },
    },
});

export default theme;
